import { createFileRoute } from '@tanstack/react-router'
import { Contratos } from '../../../app/financial/contratos'

export const Route = createFileRoute('/_auth/financial/contratos')({
  component: Contratos,
})
